(() => {
  const shieldIconUrl = 'https://cdn.shopify.com/s/files/1/0636/0494/9065/files/9004687_shield_security_safety_secure_protect_icon_1_1.svg?v=1743591592';

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const cleanValue = (value) => {
    const text = String(value || '').trim();
    if (!text) return '';

    const unsafeValues = [
      'metafield required',
      'tbd',
      'placeholder',
      'undefined',
      'null',
      'blank debug values'
    ];
    const normalized = text.toLowerCase();

    return unsafeValues.some((unsafe) => normalized.includes(unsafe)) ? '' : text;
  };

  const getReportData = (trigger) => {
    const source = trigger.closest('.mtgx-trust-portable')?.querySelector('[data-mtgx-testing-report]')
      || document.querySelector('[data-mtgx-testing-report]');
    const summaryValue = cleanValue(source?.dataset.mtgxTestingSummary);

    return {
      product: cleanValue(source?.dataset.mtgxTestingProduct),
      summary: !summaryValue || summaryValue === 'Testing summary available when attached'
        ? 'Every batch is reviewed for purity, potency, identity, heavy metals, and microbial safety.'
        : summaryValue,
      batch: cleanValue(source?.dataset.mtgxTestingBatch),
      date: cleanValue(source?.dataset.mtgxTestingDate),
      lab: cleanValue(source?.dataset.mtgxTestingLab),
      reportUrl: cleanValue(source?.dataset.mtgxTestingReportUrl),
      potency: cleanValue(source?.dataset.mtgxTestingPotency),
      purity: cleanValue(source?.dataset.mtgxTestingPurity),
      heavyMetals: cleanValue(source?.dataset.mtgxTestingHeavyMetals),
      microbial: cleanValue(source?.dataset.mtgxTestingMicrobial),
      adulterants: cleanValue(source?.dataset.mtgxTestingAdulterants),
      status: cleanValue(source?.dataset.mtgxTestingStatus)
    };
  };

  const openReportModal = (modalId, trigger) => {
    const reportData = getReportData(trigger);
    const hasFullReport = Boolean(reportData.reportUrl);
    const isVerified = reportData.status.toLowerCase() === 'verified';
    let modal = document.getElementById(modalId || 'mtgx-report-modal');

    const metaRows = [
      ['Product Name', reportData.product, 'product'],
      ['Batch Number', reportData.batch, 'batch'],
      ['Test Date', reportData.date, 'date'],
      ['Lab', reportData.lab, 'lab']
    ].filter(([, value]) => value);

    const summaryRows = [
      ['Potency / Active Content', reportData.potency || (hasFullReport ? 'See full report' : ''), !reportData.potency && hasFullReport ? reportData.reportUrl : '', 'potency'],
      ['Purity', reportData.purity || (hasFullReport ? 'See full report' : ''), !reportData.purity && hasFullReport ? reportData.reportUrl : '', 'purity'],
      ['Heavy Metals', reportData.heavyMetals, '', 'safety'],
      ['Microbial Safety', reportData.microbial, '', 'microbial'],
      ['Adulterants', reportData.adulterants, '', 'adulterants'],
      ['Verification Status', reportData.status, '', 'verified']
    ].filter(([, value]) => value);

    const metaMarkup = metaRows.map(([label, value]) => `
      <div class="mtgx-trust-modal__meta-row">
        <span>${escapeHtml(label)}</span>
        <strong>${escapeHtml(value)}</strong>
      </div>`).join('');

    const summaryMarkup = summaryRows.map(([label, value, href]) => {
      const normalizedValue = String(value || '').trim().toLowerCase();
      const rowClasses = [
        'mtgx-trust-modal__summary-row',
        href || normalizedValue === 'see full report' ? 'mtgx-trust-modal__summary-row--link' : '',
        ['pass', 'verified'].includes(normalizedValue) ? 'mtgx-trust-modal__summary-row--pass' : ''
      ].filter(Boolean).join(' ');

      return `
        <div class="${rowClasses}">
          <span>${escapeHtml(label)}</span>
          ${href ? `<a href="${escapeHtml(href)}" target="_blank" rel="noopener">${escapeHtml(value)}</a>` : `<strong>${escapeHtml(value)}</strong>`}
        </div>`;
    }).join('');

    const reportLinkMarkup = hasFullReport ? `
      <div class="mtgx-trust-modal__report-panel">
        <p>For complete test results, methodology, and COA documentation.</p>
        <a class="mtgx-trust-modal__report-link" href="${escapeHtml(reportData.reportUrl)}" target="_blank" rel="noopener">
          <span>See full report</span><span aria-hidden="true">-&gt;</span>
        </a>
      </div>` : '';

    if (!modal) {
      modal = document.createElement('div');
      modal.id = modalId || 'mtgx-report-modal';
      modal.className = 'mtgx-trust-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'mtgx-trust-modal-title');
      document.body.appendChild(modal);
    }

    modal.innerHTML = `
      <div class="mtgx-trust-modal__panel" role="document" tabindex="-1">
        <button class="mtgx-trust-modal__close" type="button" aria-label="Close testing summary">&times;</button>
        <div class="mtgx-trust-modal__header">
          <span class="mtgx-trust-modal__icon" aria-hidden="true">
            <img src="${escapeHtml(shieldIconUrl)}" alt="" aria-hidden="true" loading="lazy">
          </span>
          <div>
            <h2 id="mtgx-trust-modal-title">Testing Summary</h2>
            <p>${escapeHtml(reportData.summary)}</p>
          </div>
        </div>
        <div class="mtgx-trust-modal__certificate">
          <div class="mtgx-trust-modal__certificate-head">
            <h3>Certificate of Analysis</h3>
            ${isVerified ? '<span class="mtgx-trust-modal__badge">Verified</span>' : ''}
          </div>
          ${metaMarkup ? `<div class="mtgx-trust-modal__meta">${metaMarkup}</div>` : ''}
          ${summaryMarkup ? `<div class="mtgx-trust-modal__summary">${summaryMarkup}</div>` : ''}
          ${reportLinkMarkup}
        </div>
        <div class="mtgx-trust-modal__footer">Your trust is our standard.</div>
      </div>`;

    const panel = modal.querySelector('.mtgx-trust-modal__panel');
    modal.classList.add('is-open');
    document.body.classList.add('mtgx-trust-modal-open');
    window.setTimeout(() => panel && panel.focus(), 20);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mtgx-report-trigger]');
    if (trigger) {
      event.preventDefault();
      openReportModal(trigger.getAttribute('data-mtgx-report-trigger'), trigger);
      return;
    }

    const close = event.target.closest('.mtgx-trust-modal__close');
    const overlay = event.target.classList && event.target.classList.contains('mtgx-trust-modal');
    if (!close && !overlay) return;

    const modal = event.target.closest('.mtgx-trust-modal') || event.target;
    modal.classList.remove('is-open');
    document.body.classList.remove('mtgx-trust-modal-open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.mtgx-trust-modal.is-open').forEach((modal) => {
      modal.classList.remove('is-open');
    });
    document.body.classList.remove('mtgx-trust-modal-open');
  });
})();
